// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
// @flow

import keyMirror from 'utils/key_mirror';

export default keyMirror({
    GET_SCHEME_REQUEST: null,
    GET_SCHEME_SUCCESS: null,
    GET_SCHEME_FAILURE: null,
    RECEIVED_SCHEME: null,

    GET_SCHEMES_REQUEST: null,
    GET_SCHEMES_SUCCESS: null,
    GET_SCHEMES_FAILURE: null,
    RECEIVED_SCHEMES: null,

    CREATE_SCHEME_REQUEST: null,
    CREATE_SCHEME_SUCCESS: null,
    CREATE_SCHEME_FAILURE: null,
    CREATED_SCHEME: null,

    DELETE_SCHEME_REQUEST: null,
    DELETE_SCHEME_SUCCESS: null,
    DELETE_SCHEME_FAILURE: null,
    DELETED_SCHEME: null,

    PATCH_SCHEME_REQUEST: null,
    PATCH_SCHEME_SUCCESS: null,
    PATCH_SCHEME_FAILURE: null,
    PATCHED_SCHEME: null,

    GET_SCHEME_TEAMS_REQUEST: null,
    GET_SCHEME_TEAMS_SUCCESS: null,
    GET_SCHEME_TEAMS_FAILURE: null,
    RECEIVED_SCHEME_TEAMS: null,

    GET_SCHEME_CHANNELS_REQUEST: null,
    GET_SCHEME_CHANNELS_SUCCESS: null,
    GET_SCHEME_CHANNELS_FAILURE: null,
    RECEIVED_SCHEME_CHANNELS: null,
});
